import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './axios'
import VueAxios from 'vue-axios'
import i18n from '@/lang/index' // 国际化
// 地址配置
import urlConfig from './config/urlConfig'
// 本地存储
import localStorageUtil from './utils/localStorageUtil'
// 基础工具
import baseUtil from './utils/baseUtil'
// 微信分享
import shareUtil from './utils/shareUtil'
// 公共方法
import common from './utils/common'
// 字体库
import './assets/assemble/font-family/font-famaily.scss'

// vant
import Vant from 'vant'
import 'vant/lib/index.css'
// swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.use(Vant)
// 轮播
Vue.use(VueAwesomeSwiper)

Vue.prototype.$Vant = Vant
Vue.prototype.$urlConfig = urlConfig
Vue.prototype.$localStorageUtil = localStorageUtil
Vue.prototype.$baseUtil = baseUtil
Vue.prototype.$shareUtil = shareUtil
Vue.prototype.$common = common

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
